import { AsyncPipe } from '@angular/common';
import { Component, inject, Signal } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MenubarModule } from 'primeng/menubar';
import { map, of } from 'rxjs';
import { NavbarService, AuthService } from '#services';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-navbar',
  imports: [MenubarModule, AsyncPipe],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  menuItems$ = of<MenuItem[]>([]);

  private _navBarService = inject(NavbarService);
  private _authService = inject(AuthService);

  hasAccess: Signal<boolean>;

  constructor() {
    this.menuItems$ = this._navBarService.getNavigation();

    this.hasAccess = toSignal(this._authService.userDetails$.pipe(map(user => !!user?.hasAccess)), {
      initialValue: false,
    });
  }
}
